import React, { FC } from 'react';
import s from './createToyDraftCard.module.scss';
import { useTranslation } from '@hooks/useTranslation';
import cn from 'classnames';
import { Button } from '@components/UIKit/Button/Button';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
import { useRouter } from 'next/router';
import { useProfile } from '@hooks/TRPC_Hooks/useProfile';
import { Avatar } from '@components/UIKit/Avatar/Avatar';
import { LinksEnum } from '@specs/navigation';
interface Props {}
export const CreateToyDraftCard: FC<Props> = () => {
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  const {
    data: profile,
    isLoading
  } = useProfile();
  const clickHandler = async () => {
    await router.push(LinksEnum.USER_TOY_DRAFT);
  };
  return <div className={s.createToyDraftCard} data-sentry-component="CreateToyDraftCard" data-sentry-source-file="CreateToyDraftCard.tsx">
            <div className={s.createToyDraftCard__top}>
                <div className={s.createToyDraftCard__artist}>
                    <Avatar profile={profile} srcSet={[{
          height: 24,
          width: 24,
          minMedia: 0
        }]} isLoading={isLoading} data-sentry-element="Avatar" data-sentry-source-file="CreateToyDraftCard.tsx" />
                </div>
                <div className={cn(s.createToyDraftCard__image, '_shadow')}>
                    <SpriteIcon name={'empty_toy'} width={'100%'} height={'100%'} color={'--White-Edgar'} data-sentry-element="SpriteIcon" data-sentry-source-file="CreateToyDraftCard.tsx" />
                </div>
            </div>
            <div className={s.createToyDraftCard__main}>
                <div className={cn(s.createToyDraftCard__name, '_ellipsis')}>
                    {tr({
          id: 'create.toy.toy.name.label'
        })}
                </div>
                <div className={cn(s.createToyDraftCard__author, '_ellipsis')}>
                    {isLoading ? tr({
          id: 'btn.loading'
        }) : profile?.shortid}
                </div>
            </div>
            <Button id='create_toy_draft_button' size={'medium'} color={'Black'} onClick={clickHandler} data-sentry-element="Button" data-sentry-source-file="CreateToyDraftCard.tsx">
                {tr({
        id: 'btn.create.new'
      })}
            </Button>
        </div>;
};